var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPieFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5C16.5 6.67157 15.8264 5.99138 15.0031 6.08324C12.8626 6.32205 10.8026 7.07056 8.99981 8.27516C6.77974 9.75855 5.04941 11.867 4.02763 14.3338C3.00585 16.8006 2.7385 19.515 3.2594 22.1337C3.7803 24.7525 5.06606 27.1579 6.95406 29.0459C8.84207 30.9339 11.2475 32.2197 13.8663 32.7406C16.485 33.2615 19.1994 32.9941 21.6662 31.9724C24.133 30.9506 26.2414 29.2203 27.7248 27.0002C28.9294 25.1974 29.678 23.1374 29.9168 20.9969C30.0086 20.1736 29.3284 19.5 28.5 19.5L18 19.5C17.1716 19.5 16.5 18.8284 16.5 18L16.5 7.5Z",
    fill: "#B1B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.5C32.3284 16.5 33.0086 15.8264 32.9168 15.0031C32.7763 13.7442 32.459 12.5087 31.9724 11.3338C31.2939 9.69591 30.2995 8.20769 29.0459 6.95409C27.7924 5.7005 26.3041 4.7061 24.6662 4.02766C23.4913 3.54099 22.2559 3.22375 20.9969 3.08328C20.1736 2.99143 19.5 3.67161 19.5 4.50004V15C19.5 15.8285 20.1716 16.5 21 16.5H31.5Z",
    fill: "#B1B5C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPieFilled);
export default __webpack_public_path__ + "static/media/icon-pie-filled.72ffebf115a4e61515cefbc51fe567f8.svg";
export { ForwardRef as ReactComponent };